import { Link, Text, Stack, ImageIcon } from '@/components/lib'

export default function Footer () {
  return (
    <Stack direction='row' bg='bg.subtle' borderTopWidth='1px' borderColor='border.default' p={1} px={2} alignItems='center' justifyContent='space-between'>
      <Stack direction='row' alignItems='center'>
        <ImageIcon iconKey='trialflare' size={30} p={1} />
        <Text fontSize='xs' fontWeight='semibold' color='fg.muted'>Powered by Trialflare<br /><small>&copy; {new Date().getFullYear()} Seastorm Limited</small></Text>
      </Stack>
      <Stack direction={['column', 'row']} alignItems='center' textAlign='right' gap={4} fontSize='sm'>
        <Link as='a' href='https://trialflare.com/privacy' target='_blank' rel='noopener noreferrer'>Privacy Policy</Link>
        <Link as='a' href='https://trialflare.com/legal' target='_blank' rel='noopener noreferrer'>Terms of Use</Link>
      </Stack>
    </Stack>
  )
}
